import { useMemo } from 'react'
import { QuestionType } from '@factorialco/f0-react/dist/experimental'
import { FormDetailDocument } from 'generated/resources/graphql'

import Loading from 'modules/core/components/Loading'
import { useQuery } from 'modules/core/hooks/useQuery'

import { FromFragmentToQuestionnaire } from './helpers'
import { AgentStateType, QuestionnaireType } from './types'
import { FormEditor } from './form'

const defaultQuestionnaire: QuestionnaireType = {
  title: '',
  description: '',
  elements: [],
}

interface Props {
  id?: string
  resourceType: string
  formType?: AgentStateType['formType']
  allowedQuestionTypes?: QuestionType[]
}

const NewFormEditor = ({ id, resourceType, formType, allowedQuestionTypes }: Props) => {
  const { data: formData, loading: loadingForm } = useQuery(FormDetailDocument, {
    variables: { id: id ?? '', resourceType },
    skip: !id,
  })

  const form = formData?.forms?.form ?? null

  const initialQuestionnaire = useMemo(
    () => (form ? FromFragmentToQuestionnaire(form) : defaultQuestionnaire),
    [form]
  )

  if (id && loadingForm) {
    return <Loading expand />
  }

  return (
    <FormEditor
      form={form}
      initialQuestionnaire={initialQuestionnaire}
      resourceType={resourceType}
      formType={formType}
      allowedQuestionTypes={allowedQuestionTypes}
    />
  )
}

export default NewFormEditor
